import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { PontoEncontroDBService } from '../database/ponto-encontro-db.service';
import { firstValueFrom } from 'rxjs';
import * as moment from 'moment';
import type { AuthGuard } from '../alcance/guards/auth.guard';

@Injectable({
  providedIn: 'root'
})
export class PontoEncontroService extends BaseService{
    override classname: string = 'PontoEncontroService';
    public override route: string = 'ponto-encontro';
    public override database = new PontoEncontroDBService();

    async alternarMinhaPresenca(pontoId: number, auth: AuthGuard) {
        if (auth.presenca && Number(auth.presenca.ponto_encontro_id) !== pontoId) {
            throw new Error('Registre a saída do outro ponto de encontro antes de entrar neste.');
        }

        if (auth.online()) {
            const presenca = await firstValueFrom(this.put({id: pontoId}, 'presenca', null, {showLoader: 'false'}));
            auth.presenca = presenca || undefined;
        } else {
            await this.addToFila(this.route, 'PUT', {id: pontoId, dt_presenca: moment().format('YYYY-MM-DD HH:mm')}, 'presenca');
            auth.presenca = auth.presenca ? undefined : {
                nome: auth.usuario?.pessoa.nome as string,
                dt_presenca: moment().format('YYYY-MM-DD HH:mm'),
                ponto_encontro_id: pontoId,
                usuario_id: auth.usuario?.id
            };
        }

        return auth.presenca;
    }
}
